/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from './vuetify'
import router from '../router'

import { createGtag } from "vue-gtag";
// Types
import type { App } from 'vue'

const gtag = createGtag({
  tagId: "G-N1H2HXRJ8B",
  pageTracker: {
    router,
    template: (to) => ({
      page_path: to.path,
      page_title: to.params.file ? to.params.file : to.name
    })
  }
})

export function registerPlugins (app: App) {
  app
    .use(vuetify)
    .use(router)
    .use(gtag)
}
